import _store from 'store2'
import {
    addFile,
    addFileShare,
    clearFile,
    copyFile,
    copyMailFile,
    deleteFile,
    downFileMkdirZip,
    editFile,
    fileCancelPublicShare,
    fileCancelShare,
    filePublicShare, getCompanyAccountDataDetail,
    getFileByLinkAddress,
    getFileList,
    getFilePath,
    getFilePathShare, getPersonAndCompanyInfoDataDetail,
    getPublicShareUserList,
    getShareNameByLinkCode,
    hideFile,
    mailFileShareList,
    moveFile,
    myPublicShareList,
    publicShareOtherList,
    queryByUserId,
    queryShareFileByParentId
} from "@/api/cloud";
import {ElMessage} from "element-plus";
import {formatEchartsData} from "@/utils/echarts";

const DEFAULT_SPACE_SIZE = {
    effectiveLocation: 0,
    containsLocation: 0,
    freeLocation: 0,
    fileCloudLocation: 0,
    emailFileLocation: 0
}

function safeParseJSON(raw, fallback) {
    if (!raw) return fallback
    try {
        return JSON.parse(raw)
    } catch (e) {
        return fallback
    }
}

function getCurrentUserId() {
    try {
        const localUserInfo = safeParseJSON(localStorage.getItem('userInfo'), null)
        const storeUserInfo = _store.get('userInfo')
        const userInfo = localUserInfo || storeUserInfo || {}
        const userId = userInfo?.id ?? userInfo?.userID
        return userId === undefined || userId === null ? '' : String(userId)
    } catch (e) {
        return ''
    }
}

function getScopedStorageKey(baseKey) {
    const userId = getCurrentUserId()
    return userId ? `${baseKey}_${userId}` : ''
}

function readScopedStorage(baseKey, fallback) {
    const storageKey = getScopedStorageKey(baseKey)
    if (!storageKey) return fallback
    return safeParseJSON(localStorage.getItem(storageKey), fallback)
}

function writeScopedStorage(baseKey, value) {
    const storageKey = getScopedStorageKey(baseKey)
    if (!storageKey) return
    localStorage.setItem(storageKey, JSON.stringify(value))
}

const cloud = {
    namespaced: true, state: {
        // 是否切换路由
        isChangeRouter: false, disabled: true, downloadStatus: 'done', //loading 下载中 done 已完成
        //     文件列表
        fileList: [], total: 0, pages: 1, isCurrent: false, //  选中文件夹中的文件list
        dirFileList: [], //  是否第一次 scroll 纠正偏移
        isFirstPageLoaded: false,


        //移动文件夹
        moveFileList: [],

        //文件分享
        fileLink: {
            shareDay: 0, shareCode: "", linkAddress: "",
        },


        //     文件分享列表---链接提取码
        shareCodeFileList: [], //     是否匹配
        isCodeShareLink: false,


        //     共享用户列表
        sharedUserList: [],

        //     分享用户详情
        shareTargetUser: {},
        // tab 选中的数据，数据详情的选中项
        targetTabData: {},
        //     存储空间大小
        spaceSize: readScopedStorage('spaceSize', DEFAULT_SPACE_SIZE), // initEchart
        echartsData: [], // 布局方式
        isSelect: localStorage.getItem("isSelect") ? localStorage.getItem("isSelect") * 1 : 2, multipleSelection: [],
        userDataInformation: readScopedStorage('userDataInformation', {})
    }, mutations: {
        setMultipleSelection(state, payload) {
            state.multipleSelection = payload
        }, setIsSelect(state, payload) {
            state.isSelect = payload
            localStorage.setItem("isSelect", payload)
        }, changeDownLoadStatus(state, status) {
            state.downloadStatus = status
        }, setFileList(state, payload) {
            state.fileList = payload
        }, changeCurrent(state, payload) {
            state.isCurrent = payload;
        }, changeIsFirstPageLoaded(state, payload) {
            console.log("isFirstPageLoaded", payload,)
            state.isFirstPageLoaded = payload;
        }, changeDisabled(state, payload) {
            state.disabled = payload;
        }, changeTotal(state, payload) {
            state.total = payload;
        }, isChangeRouterPayload(state, payload) {
            state.isChangeRouter = payload
        }
    }, actions: {
        // 根据路径获取文件列表
        async getFilePathApis({state}, payload) {
            const {show, type, pageNo, pageSize, id} = payload

            const res = await getFilePath({id, type, pageNo, pageSize})
            if (res.code !== 200) {
                ElMessage.error(res.message)
                return
            }

            console.log('target by id list', res.result)
            if (show === 1) {
                state.dirFileList = res.result.records
            } else {
                if (!state.isCurrent) {
                    state.fileList = []
                    state.fileList = res.result.records;

                    state.moveFileList = [];
                    state.moveFileList = res.result.records;
                } else {
                    state.fileList = [...state.fileList, ...res.result.records];

                    state.moveFileList = [...state.moveFileList, ...res.result.records];
                }
                state.total = res.result.total
                state.pages = res.result.pages;
            }
        }, async getFilePathApisShare({state}, payload) {
            const {show, pageNo, pageSize, parentId, isRight} = payload

            const res = await getFilePathShare({parentId, pageNo, pageSize})
            if (res.code !== 200) {
                ElMessage.error(res.message)
                return
            }
            console.log('target by id list', res.result)
            if (show === 1) {
                state.dirFileList = res.result.records
            } else {
                if (!state.isCurrent) {
                    state.fileList = []
                    state.fileList = res.result.records;

                    state.moveFileList = [];
                    state.moveFileList = res.result.records;
                } else {
                    state.fileList = [...state.fileList, ...res.result.records];

                    state.moveFileList = [...state.moveFileList, ...res.result.records];
                }
                state.total = res.result.total
                state.pages = res.result.pages;
            }
        },

        async getFilePathApisMove({state}, payload) {
            const {show, type, pageNo, pageSize, id} = payload

            const res = await getFilePath({id, type, pageNo, pageSize})
            if (res.code !== 200) {
                ElMessage.error(res.message)
                return
            }

            console.log('target by id list', res.result)
            if (show === 1) {
                state.dirFileList = res.result.records
            } else {
                if (!state.isCurrent) {
                    state.moveFileList = [];
                    state.moveFileList = res.result.records;
                } else {
                    state.moveFileList = [...state.moveFileList, ...res.result.records];
                }
                state.total = res.result.total
                state.pages = res.result.pages;
            }
        },

        //  查询当前用户空间情况
        async queryByUserIdApis({state, commit}) {
            const res = await queryByUserId()
            if (res.code !== 200) {
                ElMessage.error(res.message);
                return
            }
            console.log("queryByUserIdApis", res)
            const targetObj = res.result
            try {
                targetObj.totalAiNum = res.result.totalAiNum.toFixed(2)
                targetObj.freeAiNum = res.result.freeAiNum.toFixed(2)
            } catch (e) {
                console.log(e)
            }
            state.userDataInformation = targetObj;
            state.spaceSize = res.result?.mailStorageVo;
            writeScopedStorage("spaceSize", res.result?.mailStorageVo ?? DEFAULT_SPACE_SIZE)
            writeScopedStorage("userDataInformation", targetObj)
            state.echartsData = formatEchartsData(state.spaceSize)
            const mailWorkPositionData = {
                usePosition: res.result.usePosition,
                freePosition: res.result.freePosition,
                totalPosition: res.result.totalPosition
            }
            commit('user/setMailWorkPosition', mailWorkPositionData, {root: true})  // 假设返回中有 token
        },
        // 查询 企业账户 子账户空间使用情况
        async queryByEnterprisesApis({state, commit}, payload) {
            const res = await getCompanyAccountDataDetail(payload)
            if (res.code !== 200) {
                ElMessage.error(res.message);
                return
            }
            const {type} = payload
            if (type === 1) {
                state.spaceSize = res.result?.mailStorageVo
                writeScopedStorage("spaceSize", res.result?.mailStorageVo ?? DEFAULT_SPACE_SIZE)
                console.log(state.spaceSize, 'state.spaceSizestate.spaceSizestate.spaceSize')
                state.echartsData = formatEchartsData(state.spaceSize)
                state.targetTabData = res.result;
            }
        },
        // 查询企业用户 企业信息总数据 使用情况
        async getPersonAndCompanyInfoDataDetailApis({state, commit}, payload) {
            const res = await getPersonAndCompanyInfoDataDetail(payload)
            if (res.code !== 200) {
                ElMessage.error(res.message);
                return
            }
            const {type} = payload
            state.targetTabData = res.result;
            
            // 如果有 mailStorageVo 数据，更新 echartsData
            if (res.result?.mailStorageVo) {
                console.log('Updating echartsData with mailStorageVo:', res.result.mailStorageVo)
                // 注意：这里不更新 spaceSize，因为 searchType 时应该使用 targetTabData
                // state.spaceSize = res.result.mailStorageVo
            }
        },

        // 	获取文件列表
        async getFileListApi({state,}, payload) {
            const res = await getFileList(payload)
            if (res.code !== 200) {
                ElMessage.error(res.message);
                return
            }
            console.log(state.isCurrent, 'state.isCurrent')
            if (!state.isCurrent) {
                state.fileList = []
                state.fileList = res.result.records;

                state.moveFileList = [];
                state.moveFileList = res.result.records;
            } else {
                state.fileList = [...state.fileList, ...res.result.records]
                state.moveFileList = [...state.moveFileList, ...res.result.records];
            }
            // console.log('fileList=====>', res, state.fileList)
            state.total = res.result.total;
            state.pages = res.result.pages;

        },

        // 获取文件列表---move
        async getFileListApiMove({state,}, payload) {
            const res = await getFileList(payload)
            if (res.code !== 200) {
                ElMessage.error(res.message);
                return
            }
            console.log(state.isCurrent, 'state.isCurrent')
            if (!state.isCurrent) {
                state.moveFileList = [];
                state.moveFileList = res.result.records;
            } else {
                state.moveFileList = [...state.moveFileList, ...res.result.records,];
            }
            // console.log('fileList=====>', res, state.fileList)
            state.total = res.result.total;
            state.pages = res.result.pages;

        },

        //  添加文件
        async addFile({state,}, payload) {
            const res = await addFile(payload)
            if (res.code !== 200) {
                ElMessage.error(res.message);
                return
            }
            console.log("addFile===>", res);
            return res
            // ElMessage.success(res.message)
        },

        //  文件收藏
        async hideFileApis({state}, payload) {
            const res = await hideFile(payload)
            if (res.code !== 200) {
                ElMessage.error(res.message);
                return
            }
            console.log("hideFile===>", res)
            // ElMessage.success(res.message);
        },


        //    删除文件 type	1:恢复文件,2:删除文件,3:彻底删除文件
        async deleteFileApis({state}, payload) {
            const res = await deleteFile(payload)
            if (res.code !== 200) {
                ElMessage.error(res.message);
                return
            }
            ElMessage.success(res.message)
        },

        //     修改指定文件的信息
        async editFileApis({state}, payload) {
            const res = await editFile(payload)
            if (res.code !== 200) {
                ElMessage.error(res.message);
                return
            }
            ElMessage.success(res.message)
        },

        // 清空回收站
        async clearFileApis({state,}, payload) {
            const res = await clearFile()
            if (res.code !== 200) {
                ElMessage.error(res.message);
                return
            }
            ElMessage.success(res.message)
        },

        //     移动到指定位置
        async moveFileApis({state}, payload) {
            const res = await moveFile(payload);
            if (res.code !== 200) {
                ElMessage.error(res.message);
                return
            }
            ElMessage.success(res.message)
        }, //  共享
        async filePublicShareApis({state}, payload) {
            const res = await filePublicShare(payload)
            if (res.code !== 200) {
                ElMessage.error(res.message);
                return
            }
            console.log('filePublicShareApis', res)
        },

        // 共享给我--根据文件id 获取用户列表
        async getPublicShareUserListApis({state}, payload) {
            const res = await getPublicShareUserList(payload)
            if (res.code !== 200) {
                ElMessage.error(res.message);
                return
            }
            console.log("getPublicShareUserList", res.result)
            state.sharedUserList = res.result.records;
        }, //     共享给我的
        async publicShareOtherListApis({state}, payload) {
            const res = await publicShareOtherList(payload);
            if (res.code !== 200) {
                ElMessage.error(res.message);
                return
            }
            if (!state.isCurrent) {
                state.fileList = []
                state.fileList = res.result.records;
            } else {
                state.fileList = [...state.fileList, ...res.result.records]
            }
            state.total = res.result.total;
            state.pages = res.result.pages;
        }, //     我共享的
        async myPublicShareListApis({state}, payload) {
            const res = await myPublicShareList(payload)
            if (res.code !== 200) {
                ElMessage.error(res.message);
                return
            }
            if (!state.isCurrent) {
                state.fileList = []
                state.fileList = res.result.records;
                console.log(res.result.records, 'res.result.records')
            } else {
                state.fileList = [...state.fileList, ...res.result.records]
            }
            state.total = res.result.total;
            state.pages = res.result.pages;
        }, // 取消共享
        async fileCancelPublicShareApis({state}, payload) {
            const res = await fileCancelPublicShare(payload)
            if (res.code !== 200) {
                ElMessage.error(res.message);
                return
            }
            ElMessage.success(res.message)
        }, //     分享
        async mailFileShareApis({state}, payload) {
            const res = await addFileShare(payload)
            if (res.code !== 200) {
                ElMessage.error(res.message);
                return
            }
            console.log('mailFileShare', res.result)
            const {linkAddress, shareCode, shareDay} = res.result
            state.fileLink.linkAddress = linkAddress;
            state.fileLink.shareCode = shareCode;
            state.fileLink.shareDay = shareDay;
        }, //    分享列表
        async mailFileShareListApis({state,}, payload) {
            const res = await mailFileShareList(payload)
            if (res.code !== 200) {
                ElMessage.error(res.message);
                return
            }
            if (!state.isCurrent) {
                state.fileList = []
                state.fileList = res.result.records;
            } else {
                state.fileList = [...state.fileList, ...res.result.records]
            }
            state.total = res.result.total;
            state.pages = res.result.pages;
        }, //    取消分享
        async fileCancelShareApis({state}, payload) {
            const res = await fileCancelShare(payload)
            if (res.code !== 200) {
                ElMessage.error(res.message);
                return
            }
            ElMessage.success(res.message)
        }, //     文件分享---分享链接提取文件列表
        async getFileByLinkAddressApis({state}, payload) {
            const res = await getFileByLinkAddress(payload);
            if (res.code !== 200) {
                ElMessage.error(res.message);
                return
            }
            console.log("getFileByLinkAddressApis", res);
            state.isCodeShareLink = true;
            if (!state.isCurrent) {
                state.fileList = []
                state.fileList = res.result.records;
            } else {
                state.fileList = [...state.fileList, ...res.result.records]
            }
            state.total = res.result.total;
            state.pages = res.result.pages;
        },

        // 获取分享人相关信息
        async getShareNameByLinkCodeApis({state}, payload) {
            const res = await getShareNameByLinkCode(payload)
            console.log('shareTargetUser', res.result);
            state.shareTargetUser = res.result;
        }, // 文件分享--根据父id 查询子孙
        async queryShareFileByParentIdApi({state}, payload) {
            const {show, type, pageNo, pageSize, parentId} = payload

            const res = await queryShareFileByParentId({pageNo, pageSize, parentId})
            if (res.code !== 200) {
                ElMessage.error(res.message);
                return
            }
            if (show === 1) {
                state.dirFileList = res.result.records
            } else {
                if (!state.isCurrent) {
                    state.fileList = []
                    state.fileList = res.result.records;

                    state.moveFileList = [];
                    state.moveFileList = res.result.records;
                } else {
                    state.fileList = [...state.fileList, ...res.result.records];

                    state.moveFileList = [...state.moveFileList, ...res.result.records];
                }
                state.total = res.result.total
                state.pages = res.result.pages;
            }
        }, //     文件转存
        async copyFileApis({state}, payload) {
            const res = await copyFile(payload)
            if (res.code !== 200) {
                ElMessage.error(res.message);
                return
            }
            ElMessage.success(res.message)
            console.log('copyFileApis', res)
        }, //    邮件文件转存
        async copyEmailFileApis({state}, payload) {
            const res = await copyMailFile(payload)
            if (res.code !== 200) {
                ElMessage.error(res.message);
                return
            }
            ElMessage.success(res.message)
            console.log('copyFileApis', res)
        }, //     文件夹 打包下载
        async downFileMkdirZipApis({state}, payload) {
            const res = await downFileMkdirZip(payload)
            if (res.code !== 200) {
                ElMessage.error(res.message);
                return
            }
            ElMessage.success(res.message)
            console.log('copyFileApis', res)
        }

    }
}

export default cloud
